import React from 'react';
import { AddIcon, FolderIcon, SharedStyleTypes, colors } from '@commonsku/styles';
import { FolderContainer } from './Containers';
import useFolderActionModal from './useFolderActionModal';

export interface NewFolderProps {
    folderParent: any,
}

export const NewFolder = ({ ...props }: NewFolderProps & SharedStyleTypes) => {
    const [popup, setOpen, setParent, setType] = useFolderActionModal();

    return <li key='new'>
        <a
            href="/"
            className='nav-folder'
            onClick={(e) => {
                e.preventDefault();
                setParent(props.folderParent);
                setType('new');
                setOpen(true);
            }}
        >
            <FolderContainer><AddIcon />New Folder</FolderContainer>
        </a>
        {popup}
    </li>;
};
